module.exports = __webpack_public_path__ + "static/media/LeftCaret.b62b09bb.svg";